import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ChatView from '../views/ChatView/ChatView.vue'
import LoginView from '../views/LoginView.vue'
import CallbackView from '../views/CallbackView.vue'
import VocabularyBanksView from '../views/VocabularyBanksView.vue'
import AccountView from '../views/AccountView.vue'
import RegistrationRequestView from '../views/RegistrationRequestView.vue'
import { requireAuth } from '@/auth/routeGuard'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/number-trainer',
      name: 'number-trainer',
      component: () => import('../views/NumberTrainerView.vue'),
    },
    {
      path: '/chat',
      name: 'chat',
      component: ChatView,
      beforeEnter: requireAuth,
    },
    {
      path: '/vocabulary-banks',
      name: 'vocabulary-banks',
      component: VocabularyBanksView,
      beforeEnter: requireAuth,
    },
    {
      path: '/account',
      name: 'account',
      component: AccountView,
      beforeEnter: requireAuth,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/register',
      name: 'register',
      component: RegistrationRequestView,
    },
    {
      path: '/callback', // Add callback route
      name: 'callback',
      component: CallbackView,
    },
  ],
})

export default router
